
















































































































import Vue from "vue";
import { Component } from "vue-property-decorator";
import {
  CourierBusiness,
  CourierVisibilityDTO,
  TranslatedCountryDTO
} from "@/model/component.model";
import { CustomerService } from "@/services/CustomerService";
import { cloneDeep } from "lodash";
import store from "@/vuex/store";
import { CountryDTO } from "@/model/data.model";
import { fieldSorter } from "@/services/Helpers";
import equal from "fast-deep-equal";
import { requiredIf } from "vuelidate/lib/validators";

@Component({
  validations() {
    const self = this as any;

    return {
      upsData: {
        codeAccount: {
          required: requiredIf(() => {
            return (
              self.upsData &&
              self.upsData.zipCode &&
              String(self.upsData.zipCode).trim() !== ""
            );
          })
        },
        zipCode: {
          required: requiredIf(() => {
            return (
              self.upsData &&
              self.upsData.codeAccount &&
              String(self.upsData.codeAccount).trim() !== ""
            );
          })
        }
      }
    };
  }
})
export default class DDPThirdPartCode extends Vue {
  countries: TranslatedCountryDTO[] = [];
  defaultData: CourierVisibilityDTO = {
    codeAccount: "",
    courierId: "",
    zipCode: "",
    canRequest: false,
    customerId: "",
    username: "",
    countryId: ""
  };
  upsData: CourierVisibilityDTO = cloneDeep(this.defaultData);
  upsDefaultData: CourierVisibilityDTO = cloneDeep(this.defaultData);
  fedexData: CourierVisibilityDTO = cloneDeep(this.defaultData);
  fedexDefaultData: CourierVisibilityDTO = cloneDeep(this.defaultData);
  dhlData: CourierVisibilityDTO = cloneDeep(this.defaultData);
  dhlDefaultData: CourierVisibilityDTO = cloneDeep(this.defaultData);

  async loadCountries() {
    const countries = store.cache
      .dispatch("cachemod/getCountries")
      .then((countries: CountryDTO[]) => {
        countries.sort((a: CountryDTO, b: CountryDTO) =>
          a.name < b.name ? -1 : 1
        );
        this.countries = countries
          .map(
            (country: CountryDTO): TranslatedCountryDTO => {
              const translatedCountry = {
                ...country
              } as TranslatedCountryDTO;
              translatedCountry.translatedName = this.$t(
                "country_" + country.id
              ).toString();
              return translatedCountry;
            }
          )
          .sort(fieldSorter(["translatedName"]));
      })
      .catch(() => {
        this.$snotify.error(this.$t("error_getting_countries").toString());
      });
  }

  get isDHLChanged() {
    return !equal(this.dhlData, this.dhlDefaultData);
  }

  get isUPSChanged() {
    return !equal(this.upsDefaultData, this.upsData);
  }

  get isFedexChanged() {
    return !equal(this.fedexDefaultData, this.fedexData);
  }

  get enableSaveBtn() {
    return this.isDHLChanged || this.isUPSChanged || this.isFedexChanged;
  }

  get isSaveDisabled(): boolean {
    const isCustomDutiesInvalid = !!(
      this.$v.upsData && this.$v.upsData.$invalid
    );

    return !this.enableSaveBtn || isCustomDutiesInvalid;
  }

  async initCourierVisibility() {
    try {
      await this.loadCountries();
      const listData = (await CustomerService.getCourierVisibility()) as CourierVisibilityDTO[];
      if (!listData.length) return;
      for (let index = 0; index < listData.length; index++) {
        const el = listData[index];
        if (el.courierId === CourierBusiness.UPS) {
          this.upsData = cloneDeep(el);
          this.upsDefaultData = cloneDeep(el);
          continue;
        }
        if (el.courierId === CourierBusiness.DHL) {
          this.dhlData = cloneDeep(el);
          this.dhlDefaultData = cloneDeep(el);
          continue;
        }
        if (el.courierId === CourierBusiness.FEDEX) {
          this.fedexData = cloneDeep(el);
          this.fedexDefaultData = cloneDeep(el);
        }
      }
    } catch (err) {
      console.error(err);
    }
  }

  async created() {
    await this.loadCountries();
    await this.initCourierVisibility();
  }

  async saveData() {
    if (this.$v.upsData) this.$v.upsData.$touch();

    if (this.$v.upsData && this.$v.upsData.$invalid) {
      return;
    }

    try {
      if (this.isUPSChanged) {
        this.upsDefaultData = await CustomerService.updateCourierVisibility(
          this.upsData
        );
      }
      if (this.isDHLChanged) {
        this.dhlDefaultData = await CustomerService.updateCourierVisibility(
          this.dhlData
        );
      }
      if (this.isFedexChanged) {
        this.fedexDefaultData = await CustomerService.updateCourierVisibility(
          this.fedexData
        );
      }

      this.$alerts.success(this.$t("ddp_third_part_code_success"));
    } catch (err) {
      console.error(err);
    }
  }
}
